import { useEffect, useMemo, useState } from 'react';
import throttle from 'lodash/throttle';

interface PowerFlowCenter {
  x: number;
  y: number;
}

export const usePowerFlowCenter = (
  containerRef: React.RefObject<HTMLDivElement>,
  inverterRef: React.RefObject<HTMLDivElement>
) => {
  const [powerFlowCenter, setPowerFlowCenter] = useState<PowerFlowCenter>({ x: 0, y: 0 });

  const calculateCenter = () => {
    if (inverterRef.current && containerRef.current) {
      const inverterRect = inverterRef.current.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      const relativeLeft = inverterRect.left - containerRect.left;
      const relativeTop = inverterRect.top - containerRect.top;

      setPowerFlowCenter({
        x: relativeLeft + inverterRect.width / 2,
        y: relativeTop + inverterRect.height / 2,
      });
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const throttledCalculateCenter = useMemo(() => throttle(calculateCenter, 200), []);

  useEffect(() => {
    // Timeout para asegurar que el inverter card está montado
    setTimeout(calculateCenter, 50);

    window.addEventListener('resize', throttledCalculateCenter);
    window.addEventListener('navtoggle', throttledCalculateCenter);

    return () => {
      window.removeEventListener('resize', throttledCalculateCenter);
      window.removeEventListener('navtoggle', throttledCalculateCenter);
      throttledCalculateCenter.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [throttledCalculateCenter]);

  return { powerFlowCenter };
};
